<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-3">
      <h4 class="text-uppercase">
        {{ $vuetify.lang.t(`$vuetify.labels.orderedItems`) }}
        <br />
        <span class="text-normal">
          {{ $vuetify.lang.t(`$vuetify.labels.orderedItemsCount`, totalItems, totalAmount) }}
        </span>
      </h4>
    </div>
    <div v-if="orderItems && orderItems.length > 0">
      <v-row
        v-for="orderItem in orderItems"
        :key="orderItem.id"
        class="order-item"
        :class="{ overlay: !!itemsToRemove.find(itemToRemove => orderItem.id === itemToRemove.id) }"
      >
        <div
          class="undo-btn"
          :class="{
            'undo-btn--visible': !!itemsToRemove.find(itemToRemove => orderItem.id === itemToRemove.id),
          }"
        >
          <v-btn large color="primary" @click="removeItemToRemove(orderItem)">
            <v-icon>$vuetify.icons.undo</v-icon>
          </v-btn>
        </div>

        <v-col v-if="orderItem.productId || orderItem.productVariationId" cols="12" class="d-flex justify-center">
          <TableImageComponent :image="orderItem.image" class="mr-4"></TableImageComponent>
        </v-col>

        <v-col cols="12" class="justify-center">
          <div class="text-center">
            {{ orderItem.name | multilingual(formLanguage) }}
          </div>
          <small class="text-center lighten d-block mt-n1" v-if="orderItem.sku">{{ orderItem.sku }}</small>
          <small class="text-center lighten d-block mt-n1" v-else-if="orderItem.code">{{ orderItem.code }}</small>
          <table v-if="orderItem.variationPropertiesNames" class="lighten mx-auto">
            <tr
              v-for="(variant, index) of orderItem.variationPropertiesNames[formLanguage]"
              :key="`${orderItem.id}_var_${index}`"
            >
              <td>
                <div class="lighten">{{ index }}:</div>
              </td>
              <td>
                <div class="lighten">{{ variant }}</div>
              </td>
            </tr>
          </table>
        </v-col>

        <v-col cols="4" class="text-center">
          <div>
            <span class="mr-2">{{ orderItem.amount }}x</span>
            <span>{{ orderItem.taxedUnitPrice.formatted }}</span>
          </div>
          <div
            v-if="orderItem.taxedUnitPrice.value !== orderItem.taxedPrice.value"
            class="note sale"
          >
            {{ orderItem.taxedPrice.formatted }}
          </div>
        </v-col>
        <v-spacer v-if="edittingDisabled"></v-spacer>
        <v-col cols="4" class="text-center">
          <div>{{ orderItem.taxedTotalPrice.formatted }}</div>
          <div class="note">
            {{ orderItem.totalPrice.formatted }}
            {{ $vuetify.lang.t(`$vuetify.labels.withoutWat`) }}
          </div>
        </v-col>
        <v-col v-if="!edittingDisabled" cols="4" class="text-center">
          <div v-if="!itemsToRemove.find(itemToRemove => orderItem.id === itemToRemove.id)">
            <v-btn color="transparent" class="action-button action-button--error" @click="addItemToRemove(orderItem)">
              <v-icon>$vuetify.icons.delete</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TableImageComponent from '../global/TableImageComponent.vue';

export default {
  components: {
    TableImageComponent,
  },

  props: {
    edittingDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      getOrder: 'orders/getOrder',
      itemsToRemove: 'orderDetail/getItemsToRemove',
      formLanguage: 'languages/formLanguage',
    }),

    order() {
      return this.getOrder(Number(this.$route.params.id));
    },

    orderItems() {
      if (!this.order || !this.order.items) {
        return [];
      }

      return this.order.items;
    },

    totalItems() {
      return this.orderItems.filter(orderItem => !!orderItem.sku).length;
    },

    totalAmount() {
      return this.orderItems
        .filter(orderItem => !!orderItem.sku)
        .reduce((acc, curr) => {
          acc += curr.amount;
          return acc;
        }, 0);
    },
  },

  methods: {
    ...mapActions('orderDetail', ['updateItemsToRemove']),

    addItemToRemove(item) {
      this.updateItemsToRemove([...this.itemsToRemove, item]);
    },

    removeItemToRemove(item) {
      this.updateItemsToRemove(this.itemsToRemove.filter(itemToRemove => itemToRemove.id !== item.id));
    },
  },
};
</script>

<style lang="scss" scoped>
.lighten {
  color: #9887af;
}

.note {
  color: #9887af;
  font-size: 11px;
}

.sale {
  text-decoration: line-through;
}

.order-item:not(:first-child) {
  border-top: 1px solid #e0e0e0;
}

.overlay {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #ff00003f;
  }
}

.undo-btn {
  display: none;
  position: absolute;
  top: 91%;
  left: 83%;
  z-index: 2;
  transform: translate(-50%, -50%);

  &--visible {
    display: block;
  }
}
</style>
